import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Button, Layout, Space, PageHeader } from "antd";
import "./index.scss";
import Plan from "./Plan";
import PriceTier from "./PriceTier";
import TechnicalGuide from "./TechnicalGuide";
import DomainInfo from "./DomainInfo";

const { Content } = Layout;

export default function PublishWebsite() {
  const history = useHistory();
  const [view, setView] = useState("Plan");
  const [selectedTab, setSelectedTab] = useState("Month");

  const onBackHandler = () => {
    if (view === "PriceTier") {
      setView("Plan");
    } else if (view === "TechGuide") {
      setView("PriceTier");
    } else if (view === "DomainInfo") {
      setView("TechGuide");
    } else {
      history.goBack();
    }
  };
  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            style={{ minHeight: 80 }}
            className="d-flex items-center page-header-business"
            extra={
              view === "PriceTier"
                ? [
                    <div className="button-div">
                      <Button
                        className={
                          selectedTab === "Month"
                            ? "selected-tab-button custom-btn"
                            : "button-grp-border default-button custom-btn"
                        }
                        type="primary"
                        onClick={() => {
                          setSelectedTab("Month");
                        }}
                      >
                        Monthly
                      </Button>
                      <Button
                        className={
                          selectedTab === "Annual"
                            ? "selected-tab-button custom-btn"
                            : "button-grp-border default-button custom-btn"
                        }
                        type="primary"
                        onClick={() => {
                          setSelectedTab("Annual");
                        }}
                      >
                        Annual
                      </Button>
                    </div>,
                  ]
                : []
            }
            title={
              <div className="flex items-center">
                <div
                  className="cursor-pointer flex"
                  onClick={() => onBackHandler()}
                >
                  <svg
                    width="25"
                    height="16"
                    viewBox="0 0 25 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="ml-1 ant-page-header-heading-title">
                  Publish Website
                </div>
              </div>
            }
          />
          <div className="content-container-business">
            {(() => {
              if (view === "Plan") {
                return <Plan onChoosePlan={() => setView("PriceTier")} />;
              } else if (view === "PriceTier") {
                return (
                  <PriceTier
                    onChoosePlan={() => setView("TechGuide")}
                    selectedTab={selectedTab}
                  />
                );
              } else if (view === "DomainInfo") {
                return <DomainInfo />;
              } else if (view === "TechGuide") {
                return (
                  <TechnicalGuide onChoosePlan={() => setView("DomainInfo")} />
                );
              }
            })()}
          </div>
        </Space>
      </Content>
    </Layout>
  );
}
